import { render, staticRenderFns } from "./BulkCDE.vue?vue&type=template&id=1a27d469&scoped=true"
import script from "./BulkCDE.vue?vue&type=script&lang=js"
export * from "./BulkCDE.vue?vue&type=script&lang=js"
import style0 from "./BulkCDE.vue?vue&type=style&index=0&id=1a27d469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27d469",
  null
  
)

export default component.exports